import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mail-messages-send-config',
  templateUrl: './mail-messages-send-config.component.html',
  styleUrls: ['./mail-messages-send-config.component.scss']
})
export class MailMessagesSendConfigComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
